import { memo } from "react"
import HexagonSwirl from '../assets/animations/hexagonSwirl.json';
import Lottie from "lottie-react";

interface AIAgentBorderProps {
  width?: number;
  height?: number;
}

const AIAgentBorder: React.FC<AIAgentBorderProps> = ({width=50, height=50}) => {
  return (
    <Lottie
        animationData={HexagonSwirl}
        loop={true}
        style={{
          width: `${width}px`,
          height: `${height}px`,
          position: 'absolute',
          top: '-1px',
        }}
      />
  )
}

export default memo(AIAgentBorder)
